import React from "react"
import modStyl from './index.module.scss'
import LazyIcon from "../lazy-icon"

type Props = {
  title: string
  flexAuto?: boolean
  padding?: string
  moreText?: string
  onMore?: ()=> void
}

const PanelLayout: React.FC<Props> = ({title, children, onMore, moreText='更多', padding="12px 16px", flexAuto = false})=> {
  return (
    <div className={modStyl.wrapper} style={flexAuto ? {flex: 1, padding} : {padding}}>
      <div className={modStyl.header}>
        <h2>{title}</h2>
        {
          onMore && (
            <button onClick={onMore} type="button">
              <span>{moreText}</span>
              <LazyIcon name="arrow-right"/>
            </button>
          )
        }
      </div>
      <div className={modStyl.body}>
        {children}
      </div>
    </div>
  )
}

export default PanelLayout
